import { Button, Grid, InputAdornment, Typography } from '@mui/material';
import { useCustomStyles } from '../../../../style/global';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import InputFilled from '../../../UI/Input/InputFilled';
import { fnLocalizeFilter } from '../../../../services/localize.service';
import classNames from 'classnames';
import { useStyles } from '../style';
import { useGlobalContext } from '../../../../services/context.service';
import React, { useState } from 'react';
import { TShowTypeForm } from '../Auth';
import { authAPI } from '../../../../services/authAPI.service';
import IconButton from '@mui/material/IconButton';


interface ISendOTP {
  phone: string;
  type: TShowTypeForm;

  sendOTP(): void;

  goHome(): void;
}

interface IStatePass {
  pass: string;
  otp: string;
  isShowPassword: boolean;
}

export default function GetNewPass({ phone, type, goHome, sendOTP }: ISendOTP) {
  const classes = useStyles();
  const global = useCustomStyles();
  const { locale } = useGlobalContext();
  const [isRetrySendOTP, setRetrySendOTP] = useState(false);

  const [getRegister] = authAPI.useLazyUserRegisterOrForgotQuery();

  const [newPass, setPass] = useState<IStatePass>({
    pass: '',
    otp: '',
    isShowPassword: false,
  });

  const handleChangePass = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const newState = {
      ...newPass,
      [name]: value,
    };

    setPass(newState);
  };

  const handleRegister = () => {
    /* Действие с паролем */
    getRegister({ locale, otp: newPass.otp, phone, password: newPass.pass, type })
      .then(res => {
        const errorCode = (res && res.data && res.data.errorCode !== undefined) ? res.data.errorCode : -1;
        if (errorCode === 1000) setRetrySendOTP(true);
        if (errorCode === 0) {
          goHome();
        }
      });
  };

  const handleShowPassword = () => {
    setPass(prev => ({ ...prev, isShowPassword: !prev.isShowPassword }));
  };

  const sendOTPAgain = () => {
    setRetrySendOTP(false);
    sendOTP();
  };

  return <>
    <Grid item
          className={global.textDefault}>{fnLocalizeFilter(locale, '_lang.module.register.welcomeTextOTP')}
    </Grid>
    <Grid style={{ marginBottom: isRetrySendOTP ? '.9rem' : '2.2rem' }}>
      <InputFilled label={fnLocalizeFilter(locale, '_lang.module.register.titleOTP')} name={'otp'}

                   onChange={handleChangePass}
      />
      {
        isRetrySendOTP && <Typography className={classNames(global.textDefault, classes.btnRegister)}
                                      style={{ fontSize: '13px', textAlign: 'center', fontWeight: 700 }}
                                      onClick={sendOTPAgain}
        >{fnLocalizeFilter(locale, '_lang.module.login.btnResendOTP')}</Typography>
      }
    </Grid>


    <Typography
      className={global.textDefault}>{fnLocalizeFilter(locale, '_lang.module.register.titleForPass')}</Typography>

    <InputFilled label={fnLocalizeFilter(locale, '_lang.module.register.titleEnterPass')} name={'pass'}
                 onChange={handleChangePass}
                 type={!newPass.isShowPassword ? 'password' : 'text'}
                 InputProps={{
                   endAdornment: <InputAdornment position='end'>
                     <IconButton onClick={handleShowPassword} edge='end'>
                       {!newPass.isShowPassword ? <VisibilityOff /> : <Visibility />}
                     </IconButton>
                   </InputAdornment>,
                 }}
                 sx={{ '& .MuiInputBase-root:after, & .MuiInputBase-root:before': { display: 'none' } }}
    />

    <Button variant='contained'
            disabled={(newPass.pass === '' || newPass.otp === '')}
            style={{
              width: '100%',
              marginTop: '.7rem',
              padding: '.7rem 0',
            }}
            onClick={handleRegister}
    > {
      (type === 'register')
        ? fnLocalizeFilter(locale, '_lang.module.register.btnRegisterOTP')
        : fnLocalizeFilter(locale, '_lang.module.register.btnUpdatePassOTP')
    }</Button>

    <Typography className={classNames(global.textDefault, classes.btnRegister)}
                style={{ margin: '.5rem auto', fontSize: '12px' }}
                onClick={goHome}
    >{fnLocalizeFilter(locale, '_lang.module.login.btnEnter')}</Typography>

  </>;
}
